function activeList(list) {
    return Array.isArray(list)
        ? list.filter(item => item != null && Number(item.syncStatus) !== 1)
        : [];
}

export function validateDocumentDetailResponse(data, companyUUID, invoiceUUID, allowedTypes) {
    if (data == null || data.errorCode !== 0 || data.invoice == null) {
        throw new Error('Document response is invalid');
    }
    if (data.invoice.innerUUID != null && data.invoice.innerUUID !== ''
        && data.invoice.innerUUID !== invoiceUUID) {
        throw new Error('Document response is invalid');
    }
    if (data.invoice.type != null && Array.isArray(allowedTypes) && allowedTypes.length > 0
        && !allowedTypes.map(Number).includes(Number(data.invoice.type))) {
        throw new Error('Document response is invalid');
    }
    data.itemList = activeList(data.itemList);
    data.taxInfoList = activeList(data.taxInfoList);
    data.payHistoryList = activeList(data.payHistoryList);
    data.invoiceImageList = activeList(data.invoiceImageList);
}
